module.exports = __webpack_public_path__ + "img/02-BABO.45194b07.png";